/* eslint-disable */
export default {
  all: 'Alles',
  company: 'Bedrijf',
  personal: 'Persoonlijk',
} as const;

// @key: @#@"all"@#@ @source: @#@"All"@#@
// @key: @#@"company"@#@ @source: @#@"Company"@#@
// @key: @#@"personal"@#@ @source: @#@"Personal"@#@
